/**
 * Collects the moves, lines and curves a glyph path draws into contours, in device space: 16.16
 * px with y up, as FreeType's `cf2_builder_*` callbacks receive them. A contour starts at the
 * first line or curve after a move, so a move that nothing follows draws nothing.
 *
 * Portions ported from FreeType (FreeType Project License).
 * Copyright 2007-2014 Adobe Systems Incorporated.
 * See THIRD-PARTY-NOTICES.md.
 */
import { ContourPointTag } from '../../../../godot/text/textServerEnums';
export class ContourBuilder {
    contours;
    startX = 0;
    startY = 0;
    open = null;
    /** Every contour of the glyph is added to `contours`, which a `seac` accent and base share. */
    constructor(contours) {
        this.contours = contours;
    }
    moveTo(x, y) {
        this.startX = x;
        this.startY = y;
        this.open = null;
    }
    lineTo(x, y) {
        const contour = this.contour();
        contour.x.push(x);
        contour.y.push(y);
        contour.tags.push(ContourPointTag.ON);
    }
    curveTo(x1, y1, x2, y2, x3, y3) {
        const contour = this.contour();
        contour.x.push(x1, x2, x3);
        contour.y.push(y1, y2, y3);
        contour.tags.push(ContourPointTag.OFF_CUBIC, ContourPointTag.OFF_CUBIC, ContourPointTag.ON);
    }
    /** The open contour, which the first draw after a move starts at the move's point. */
    contour() {
        if (!this.open) {
            this.open = { x: [this.startX], y: [this.startY], tags: [ContourPointTag.ON] };
            this.contours.push(this.open);
        }
        return this.open;
    }
}
//# sourceMappingURL=cffPen.js.map